/**
 * HomeSLDemoPeopleContentView
 *
 * Functional component — logic + state-based JSX rendering.
 *
 * @generated from schema
 * @trait HomeSLDemoPeopleContent
 */

import { useHomeSLDemoPeopleContentLogic } from '@/hooks/traits/useHomeSLDemoPeopleContentLogic';
import type { HomeSLDemoPeopleContentConfig } from '@/hooks/traits/useHomeSLDemoPeopleContentLogic';
import type { EntityRow, EntityWith, EventPayload, EventPayloadValue, FieldValue } from '@almadar/core';
function getNestedValue(obj: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined, path: string): FieldValue | undefined {
  if (obj === null || obj === undefined || !path) return undefined;
  if (typeof obj !== 'object') return undefined;
  if (!path.includes('.') && !Array.isArray(obj)) {
    return (obj as Record<string, FieldValue | undefined>)[path];
  }
  let value: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined = obj;
  for (const part of path.split('.')) {
    if (value === null || value === undefined || typeof value !== 'object') return undefined;
    if (Array.isArray(value)) {
      if (!/^\d+$/.test(part)) return undefined;
      value = (value as readonly (EventPayloadValue | FieldValue | null | undefined)[])[Number(part)];
      continue;
    }
    value = (value as Record<string, FieldValue | undefined>)[part];
  }
  return value as FieldValue | undefined;
}
import type { HomeSLDemoPeopleLeave } from '@app/shared';
import { Split } from '@almadar/ui/components';
import { HomeSLDemoPeopleTypeChartView } from '@/components/traits/HomeSLDemoPeopleTypeChartView';
import { Typography } from '@almadar/ui/components';
import { Stack } from '@almadar/ui/components';
import { Card } from '@almadar/ui/components';
import { HomeSLDemoPeopleCalendarView } from '@/components/traits/HomeSLDemoPeopleCalendarView';
import { HomeSLDemoPeopleStatsView } from '@/components/traits/HomeSLDemoPeopleStatsView';
import { UISlotComponent, renderPatternValue } from '@almadar/ui/components';
import { TraitScopeProvider } from '@almadar/ui/providers';
import { useTranslate } from '@almadar/ui/hooks';

interface HomeSLDemoPeopleContentViewProps {
  config?: Partial<HomeSLDemoPeopleContentConfig>;
}

export function HomeSLDemoPeopleContentView({ config: propsConfig }: HomeSLDemoPeopleContentViewProps) {
  const { t: __t, locale: __locale } = useTranslate();
  const { state, data, lastPayload, lastEvent, slotWriter, loading, pendingEvent, pendingFrom, error, fields, dispatch, actions, config } = useHomeSLDemoPeopleContentLogic(propsConfig);

  // Entity collection from server response data
  const entity: EntityRow[] = data['HomeSLDemoPeopleLeave'] ?? [];
  // Payload from last event (for @payload bindings in render-ui)
  const payload = lastPayload;

  return (
    <TraitScopeProvider orbital="HomeSL" trait="HomeSLDemoPeopleContent">
      {slotWriter['main'] === 'INIT' ? (<Stack className="p-5" direction="vertical" gap="md"><Stack direction="vertical" gap="none"><Typography content={renderPatternValue(__t("std-almadar-demo-people-page:page.title"))} variant="h3" /><Typography variant="small" content={renderPatternValue(__t("std-almadar-demo-people-page:page.subtitle"))} color="muted" /></Stack><Split ratio="3:1" gap="md"><Card padding="sm"><HomeSLDemoPeopleCalendarView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /></Card><Stack gap="md" direction="vertical"><HomeSLDemoPeopleStatsView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /><Card padding="sm"><HomeSLDemoPeopleTypeChartView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /></Card></Stack></Split></Stack>) : null}
    </TraitScopeProvider>
  );
}

export default HomeSLDemoPeopleContentView;
